import styled from '@xstyled/styled-components'

export const MoteEditDialogActionsContainer = styled.divBox({
  display: 'flex',
  alignItems: 'center',
  gap: '2'
})
